export function mapSupabaseErrorMessage(errorMessage: string | undefined): string {
  if (!errorMessage) return 'An unexpected error occurred. Please try again.';
  const err = errorMessage.toLowerCase();

  if (err.includes('invalid_credentials') || err.includes('invalid login credentials')) {
    return 'Invalid email or password. Please check your credentials.';
  }
  if (err.includes('email not confirmed')) {
    return 'Please verify your email before signing in';
  }
  if (err.includes('user_not_found')) {
    return 'No account found with this email address.';
  }
  if (err.includes('email_already_registered') || err.includes('user_already_registered') || err.includes('user already registered')) {
    return 'An account with this email already exists. Please sign in instead.';
  }
  if (err.includes('weak_password')) {
    return 'Password is too weak. Please choose a stronger password.';
  }
  if (err.includes('password_too_short')) {
    return 'Password must be at least 6 characters long.';
  }
  if (err.includes('new password should be different from the old password')) {
    return 'New password cannot match recently used password';
  }
  if (err.includes('invalid_email')) {
    return 'Please enter a valid email address.';
  }
  if (err.includes('email_rate_limit')) {
    return 'Too many email requests. Please wait before trying again.';
  }
  if (err.includes('signup_disabled')) {
    return 'Account registration is currently disabled. Please try again later.';
  }
  if (err.includes('network') || err.includes('connection')) {
    return 'Network error. Please check your internet connection and try again.';
  }
  if (err.includes('timeout')) {
    return 'Request timed out. Please try again.';
  }
  if (err.includes('rate_limit')) {
    return 'Too many attempts. Please wait a moment before trying again.';
  }
  if (err.includes('server_error') || err.includes('internal_server_error')) {
    return 'Server error. Please try again later.';
  }
  if (err.includes('token_expired')) {
    return 'Session expired. Please sign in again.';
  }
  if (err.includes('captcha')) {
    return 'Please complete the captcha verification.';
  }

  return 'An unexpected error occurred. Please try again.';
}

